var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.462 24.421l10.334 11.81a2.526 2.526 0 01-3.803 3.327L15.204 26.085a2.526 2.526 0 010-3.328l11.79-13.473a2.526 2.526 0 013.802 3.327l-10.334 11.81z",
    id: "back_svg__a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "back_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#back_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#back_svg__a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#back_svg__b)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h48v48H0z"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+PGRlZnM+PHBhdGggZD0iTTIwLjQ2MiAyNC40MjFsMTAuMzM0IDExLjgxYTIuNTI2IDIuNTI2IDAgMCAxLTMuODAzIDMuMzI3TDE1LjIwNCAyNi4wODVhMi41MjYgMi41MjYgMCAwIDEgMC0zLjMyOGwxMS43OS0xMy40NzNhMi41MjYgMi41MjYgMCAwIDEgMy44MDIgMy4zMjdsLTEwLjMzNCAxMS44MXoiIGlkPSJhIi8+PC9kZWZzPjxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+PG1hc2sgaWQ9ImIiIGZpbGw9IiNmZmYiPjx1c2UgeGxpbms6aHJlZj0iI2EiLz48L21hc2s+PHVzZSBmaWxsPSJjdXJyZW50Q29sb3IiIGZpbGwtcnVsZT0ibm9uemVybyIgeGxpbms6aHJlZj0iI2EiLz48ZyBtYXNrPSJ1cmwoI2IpIiBmaWxsPSJjdXJyZW50Q29sb3IiPjxwYXRoIGQ9Ik0wIDBoNDh2NDhIMHoiLz48L2c+PC9nPjwvc3ZnPg==";
export { SvgBack as ReactComponent };